import { Controller } from "@hotwired/stimulus"

let crmReceivableAccountDatatable;
let crmReceivableAccountUpPartTableFixedHeader;

export default class extends Controller {
  static values = { pageLength: Number }

  connect() {
    const normalColumns = [
      {"data": "crmthrank", bSortable: false},
      {"data": "crmshort", bSortable: false},
      {"data": "cricrank"},
      {"data": "clientproperty", bSortable: false},
      {"data": "sum_receive"},
      {"data": "sum_receive_gt1_years"},
      {"data": "aging_amount_lt3_months"},
      {"data": "aging_amount_4to12_months"},
      {"data": "aging_amount_gt1_years"},
      {"data": "sign_receive"},
      {"data": "unsign_receive_gt1_years"},
      {"data": "unsign_receive"},
      {"data": "acc_receive_lt3_months"},
      {"data": "acc_receive_4to12_months"},
      {"data": "acc_receive_gt1_years"},
      {"data": "acc_receive"}
    ];

    crmReceivableAccountDatatable = $('#customer-receivable-account-uppart-datatable').DataTable({
      "processing": true,
      "serverSide": true,
      "pageLength": this.pageLengthValue,
      "autoWidth": false,
      "ajax": $('#customer-receivable-account-uppart-datatable').data('source'),
      "pagingType": "numbers",
      "info": false,
      "columns": normalColumns,
      "dom":
        "<'text-end'<'d-inline-block'B><'d-inline-block ms-5'l>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
      "order": [[ 4, 'desc' ]],
      stateSave: true,
      stateSaveCallback: function(settings, data) {
          localStorage.setItem('DataTables_customer-receivable-account', JSON.stringify(data));
        },
      stateLoadCallback: function(settings) {
        return JSON.parse(localStorage.getItem('DataTables_customer-receivable-account'));
        }
    });

    crmReceivableAccountUpPartTableFixedHeader = new $.fn.dataTable.FixedHeader(crmReceivableAccountDatatable, {
      header: true,
      footer: false,
      headerOffset: 50,
      footerOffset: 0
    });
  }

  disconnect() {
    crmReceivableAccountUpPartTableFixedHeader.destroy();
    crmReceivableAccountDatatable.destroy();
  }
}
